// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hbar-chart {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 8px 0 4px;
}

.hbar-gridlines {
  position: absolute;
  top: 0;
  bottom: 24px;
  left: 200px;
  right: 70px;
  pointer-events: none;
}

.hbar-gridline {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
}

.hbar-row {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  height: 32px;
  margin-bottom: 2px;
  border-radius: 6px;
  padding: 0 4px;
}

.hbar-row-hovered {
  background: var(--an-surface-hover);
}

.hbar-label {
  flex: 0 0 188px;
  font-size: 12.5px;
  color: var(--an-text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hbar-track {
  flex: 1 1;
  height: 24px;
  display: flex;
  align-items: center;
}

.hbar-fill {
  height: 24px;
  border-radius: 0 4px 4px 0;
  min-width: 2px;
  transition: width 0.2s ease;
}

.hbar-value {
  flex: 0 0 62px;
  text-align: right;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--an-text);
  font-variant-numeric: tabular-nums;
}

.hbar-tooltip {
  position: absolute;
  top: -6px;
  left: 200px;
  transform: translateY(-100%);
  background: #0b0b0b;
  color: #fff;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  white-space: nowrap;
  z-index: 10;
  pointer-events: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.28);
}

.hbar-threshold-line {
  position: absolute;
  top: 0;
  bottom: 24px;
  border-left: 2px dashed var(--an-text-muted);
  z-index: 2;
  pointer-events: none;
}

.hbar-threshold-label {
  position: absolute;
  top: -18px;
  transform: translateX(-50%);
  font-size: 11px;
  color: var(--an-text-muted);
  white-space: nowrap;
  background: var(--an-surface);
  padding: 0 4px;
}

.hbar-overflow-note {
  margin-top: 6px;
  font-size: 12px;
  color: var(--an-text-faint);
  font-style: italic;
}

.hbar-empty {
  padding: 32px 0;
  text-align: center;
  color: var(--an-text-faint);
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Analytics/charts/HorizontalBarChart.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,WAAW;EACX,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,4CAA4C;EAC5C,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB","sourcesContent":[".hbar-chart {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding: 8px 0 4px;\n}\n\n.hbar-gridlines {\n  position: absolute;\n  top: 0;\n  bottom: 24px;\n  left: 200px;\n  right: 70px;\n  pointer-events: none;\n}\n\n.hbar-gridline {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n}\n\n.hbar-row {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  height: 32px;\n  margin-bottom: 2px;\n  border-radius: 6px;\n  padding: 0 4px;\n}\n\n.hbar-row-hovered {\n  background: var(--an-surface-hover);\n}\n\n.hbar-label {\n  flex: 0 0 188px;\n  font-size: 12.5px;\n  color: var(--an-text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.hbar-track {\n  flex: 1;\n  height: 24px;\n  display: flex;\n  align-items: center;\n}\n\n.hbar-fill {\n  height: 24px;\n  border-radius: 0 4px 4px 0;\n  min-width: 2px;\n  transition: width 0.2s ease;\n}\n\n.hbar-value {\n  flex: 0 0 62px;\n  text-align: right;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--an-text);\n  font-variant-numeric: tabular-nums;\n}\n\n.hbar-tooltip {\n  position: absolute;\n  top: -6px;\n  left: 200px;\n  transform: translateY(-100%);\n  background: #0b0b0b;\n  color: #fff;\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  white-space: nowrap;\n  z-index: 10;\n  pointer-events: none;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.28);\n}\n\n.hbar-threshold-line {\n  position: absolute;\n  top: 0;\n  bottom: 24px;\n  border-left: 2px dashed var(--an-text-muted);\n  z-index: 2;\n  pointer-events: none;\n}\n\n.hbar-threshold-label {\n  position: absolute;\n  top: -18px;\n  transform: translateX(-50%);\n  font-size: 11px;\n  color: var(--an-text-muted);\n  white-space: nowrap;\n  background: var(--an-surface);\n  padding: 0 4px;\n}\n\n.hbar-overflow-note {\n  margin-top: 6px;\n  font-size: 12px;\n  color: var(--an-text-faint);\n  font-style: italic;\n}\n\n.hbar-empty {\n  padding: 32px 0;\n  text-align: center;\n  color: var(--an-text-faint);\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
